// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { change } from 'redux-form'
import updatePassiveStoreFromForm from './updatePassiveStoreFromForm'
import {
  initialFrequencyPlanValues,
  initialLossValues,
  initialRadioValues,
  makeInitialAntennaValues,
} from '../initialValues'

// when changing bands, there are a number of things we need to do:
// - On Path ends
// - - Clear all antenna data save for centerline and tilt.
// - - Clear all radio data
// - - Clear all Loss and frequencies data
// - On Passive Repeaters
// - - Clear antenna data leaving centerline.
// - - Leave common loss data for back-to-back
const handleBandChange = (e, c) => (dispatch, getState) => {
  // tell redux form to change the band's value
  c(e)

  const sourceForm = getState().pathDetails.get('sourceForm')

  // then remove all values which cannot persist accordingly
  const {
    antennas,
    frequencyPlans,
    passiveRepeaters,
    unitType,
  } = getState().form[sourceForm].values

  // creates an object of initial antenna values while persisting
  // centerline, centerlineUnit and tilt
  const clearAntennaSet = antSet => (
    antSet.map(ant => {
      const {
        centerline = '',
        centerlineUnit = unitType,
        mode,
        tilt,
      } = ant

      return {
        ...makeInitialAntennaValues(centerlineUnit),
        centerline,
        mode,
        tilt,
      }
    })
  )

  const cleanAntennas = antennas.map(clearAntennaSet)

  const cleanPassives = passiveRepeaters.map(({ antennas, backToBack, site }) => ({
    antennas: clearAntennaSet(antennas),
    backToBack,
    site,
  }))

  // make sure to persist hi/lo counts but set everything else to default values.
  const cleanFrequencyPlans = frequencyPlans.reduce((a, d, i) => {
    const {
      environmentHiLoSummary,
      projectHiLoSummary,
    } = d

    a.push({
      ...initialFrequencyPlanValues,
      environmentHiLoSummary,
      projectHiLoSummary,
    })
    return a
  }, [])

  dispatch(change(sourceForm, 'passiveRepeaters', cleanPassives))
  dispatch(change(sourceForm, 'antennas', cleanAntennas))
  dispatch(change(sourceForm, 'radios', [initialRadioValues, initialRadioValues]))
  dispatch(change(sourceForm, 'losses', [initialLossValues, initialLossValues]))
  dispatch(change(sourceForm, 'frequencyPlans', cleanFrequencyPlans))
  dispatch(updatePassiveStoreFromForm(sourceForm))
}

export default handleBandChange
